// Website related settings
const settings = {
  isSplash: true,
  useCustomCursor: false,
};

//Home Page
const greeting = {
  title: "Hello, World! 👋",
  title2: "Koushik",
  logo_name: "Koushik Saha",
  // nickname: "harry / picleric",
  full_name: "Koushik Saha",
  subTitleHead: "💻 Building the Future, One Line of Code at a Time!",
  subTitle:
    "I’m Koushik Saha, a Senior Software Engineer passionate about crafting scalable, high-performance web experiences. 🚀",
  subtitle01:
    "From React & Next.js wizardry to powering 1M+ users with dynamic micro front-ends, I turn ideas into seamless digital experiences",
  subtitle02: "⚡ Tech Enthusiast | UI Perfectionist | Problem-Solver",
  subtitle03:
    "There’s no bug too tough, no UI too complex, and no coffee too strong! ☕",
  resumeLink:
    "https://drive.google.com/file/d/1sf4S3TWcIrjos2gt7E3GinSBWIAwOVwF/view?usp=sharing",
  mail: "mailto:koushik.saha666@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/Koushik-Saha",
  linkedin: "https://www.linkedin.com/in/koushik-saha20/",
  gmail: "koushik.saha666@gmail.com",
  facebook: "https://www.facebook.com/KoushikSaha678/",
  twitter: "https://twitter.com/Koushik5122",
  instagram: "https://www.instagram.com/koushik_saha_/",
};

const skills = {
  data: [
    {
      title: "Front-End Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive User Interfaces and Backend for web applications",
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Open Source Enthusiast, Life Long Learner",
        "⚡ Passionate about Javascript, ReactJS, NodeJS",
        "⚡ Vast experience on ant design which is the most used react base UI framework right now",
      ],
      softwareSkills: [
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#563d7c",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "SASS",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563d7c",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Slack",
          fontAwesomeClassname: "simple-icons:slack",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0865A6",
          },
        },
        {
          skillName: "Jira",
          fontAwesomeClassname: "simple-icons:jira",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Bitbucket",
          fontAwesomeClassname: "simple-icons:bitbucket",
          style: {
            color: "#207297",
          },
        },
      ],
    },
    {
      title: "Back-End Development",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Creating application backend in Node & Laravel",
        "⚡ Integration of third party services such as Firebase/ AWS",
        "⚡ Create backend APIs using PHP & JavaScipt",
        "⚡ Vast knowledge of RESTful APIs & MySQL Database design",
      ],
      softwareSkills: [
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
          style: {
            color: "#6C6C6C",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#207297",
          },
        },
        {
          skillName: "Linux",
          fontAwesomeClassname: "simple-icons:linux",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#339933",
          },
        },
      ],
    },
    {
      title: "Research & Development",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Swarm robotics for warehouse automation",
        "⚡ Diabetes assistance for elderly patients",
        "⚡ Smart energy solutions for homes & businesses with apps controlling appliances",
      ],
      softwareSkills: [
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "California State University, Northridge",
      subtitle: "Master in Engineering Management",
      logo_path: "SRM_Logo.png",
      alt_name: "CSUN",
      duration: "2023 - Present",
      descriptions: [
        "⚡  I'm graduating with a Master of Engineering Management from California State University, Northridge",
        "⚡ I have studied core subjects like Six sigma, Quality management, Project management, etc.",
        "⚡ I have implemented several projects based on what I've learn under my Engineering Management course. ",
      ],
      website_link: "https://www.csun.edu",
    },
    {
      title: "North South University",
      subtitle: "Bachelors in Computer Science and Engineering",
      logo_path: "SRM_Logo.png",
      alt_name: "NorthSouthUniversity",
      duration: "2014 - 2019",
      descriptions: [
        "⚡  I'm graduating with a Bachelor of Science in Computer Science and Engineering from North South University in 2019",
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: "http://www.northsouth.edu/",
    },
    {
      title: "Narail Government Victoria College",
      subtitle: "Higher Secondary Education",
      logo_path: "monogram.jpeg",
      alt_name: "NorthSouthUniversity",
      duration: "2011 - 2013",
      descriptions: [
        "⚡  I'm graduating with a Higher Secondary Education from Narail Government Victoria College in 2013",
      ],
      website_link: "http://www.ngvc.edu.bd/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Hackathon",
      subtitle: "Backyard Hacks 2.0",
      logo_path: "hackathon1.png",
      // certificate_link:
      //   "https://drive.google.com/file/d/1Y-HT1flWDfeyfnfqVr3ubNgGIcnuUEYt/view?usp=sharing",
      alt_name: "hackathon",
      color_code: "#f47e2c",
    },
    {
      title: "Hackathon",
      subtitle: "HyperHacks",
      logo_path: "hackathon2.png",
      // certificate_link:
      //   "https://drive.google.com/file/d/1Y-HT1flWDfeyfnfqVr3ubNgGIcnuUEYt/view?usp=sharing",
      alt_name: "hackathon",
      color_code: "#E2405F",
    },
    {
      title: "Competitive Programming",
      subtitle: "Reply Challenges",
      logo_path: "Reply.jfif",
      // certificate_link: "https://drive.google.com/file/d/1KamrXJPTrF3zfMuEerbSnFUjOkt-agKT/view",
      alt_name: "Reply",
      color_code: "#2AAFED",
    },
    {
      title: "Competitive Programming",
      subtitle: "Google Hash Code",
      logo_path: "google_logo.png",
      // certificate_link: "https://drive.google.com/file/d/1sD6GS8f2Fh5MHMWlf5DhXoMhu4mykW-f/view",
      alt_name: "Reply",
      color_code: "#2AAFED",
    },
    {
      title: "Training",
      subtitle: "30 Days of Open Source",
      logo_path: "CFC.jfif",
      // certificate_link: "https://drive.google.com/file/d/1SAKHjKisJIY3-FRZQGKLusdsGDusXAjX/view",
      alt_name: "Postman",
      color_code: "#a60000",
    },
    {
      title: "Training",
      subtitle: "Git Learning",
      logo_path: "Progate.png",
      // certificate_link:
      //   "https://drive.google.com/file/d/1sD6GS8f2Fh5MHMWlf5DhXoMhu4mykW-f/view",
      alt_name: "Reply",
      color_code: "#88e7ce",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteer-ship",
  description:
    "Experienced software engineer skilled in JavaScript, React JS, and NEXT JS, recognized for elevating UI design and steering projects to success. Orchestrated teams, resulting in a notable 30% enhancement in project eﬃciency and a remarkable 40% uplift in work standards within innovative organizations.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Software Engineer",
          company: "Powerley",
          company_url: "https://powerley.com/",
          logo_path: "Technocolabs.jfif",
          duration: "January 2023 - Present",
          location: "333 W 7th St #200, Royal Oak, MI 48067\n",
          description: `Worked with 7 US-based front-end developers to create 
                    a mobile-friendly power project using JavaScript and React JS, boosting 
                    user engagement by 30% and ensuring device accessibility.Engineered a React 
                    JS-powered system for power supply calculations, achieving a 20% increase in
                     accuracy and eﬃciency.Crafted a React JS component library for eﬃcient UI 
                     development.Launched an NPM library for components, optimizing development with
                      a 40% reduction in time and enhancing code reusability by 50%.Used Tailwind 
                      CSS and Docker to streamline development and deployment, reducing deployment 
                      time by 30% and enhancing application scalability.`,
          color: "#F7DF1E",
        },
        {
          title: "Software Engineer",
          company: "Codemen Solution Inc",
          company_url:
            "https://www.linkedin.com/company/codemen-solutions-inc-/",
          logo_path: "Technocolabs.jfif",
          duration: "May 2021 - January 2023",
          location:
            "90/B,Uttara bank building (4th floor), Malibagh Chowdhury Para, " +
            "1219 DIT Rd, Dhaka 1219, Bangladesh\n",
          description: `Proﬁcient in React JS, skilled in functional and class components.
                     Implemented micro front-end architecture, improving performance and scalability
                      by 25%.Created a React JS-based SVG modiﬁer library, enhancing productivity for
                       graphic design tasks by 40% with Photoshop-like functionalities for layer 
                       creation, drag- and-drop, and advanced editing features.Optimized MongoDB 
                       for eﬃcient data storage and retrieval. Contributed to a Bootstrap-inspired 
                       UI library, cutting UI development time by 50%.`,
          color: "#62cff0",
        },
        {
          title: "Software Engineer",
          company: "MoveOn Technology",
          company_url: "https://moveon.com.bd/",
          logo_path: "Technocolabs.jfif",
          duration: "July 2019 - May-2021",
          location: "Plot 1020, Road, 9 Avenue 9, Dhaka 1216",
          description: `MoveOn landing website is using Next JS and React JS. It has 
                    total 4 panel, MoveOn landing and product page using Next JS and Dashboard 
                    is using React Js. MoveOn Url: https://moveon.com.bd/ . Ali2Bd landing website
                     using Next JS and react JS and also build a PWA app using fully redux which
                      is working on play store and app store. Also build a admin panel using ant design. 
                      Website: https://ali2bd.com/ , Mobile: https://mobile.ali2bd.com/ .Built PHP and
                       Laravel backend APIs, reducing API response time by 20% and boosting system 
                       performance by 30%.`,
          color: "#0071C5",
        },
        {
          title: "Junior Software Engineer",
          company: "BDSOFT-IT",
          company_url: "https://www.google.com/",
          logo_path: "TSF.png",
          duration: "June 2018 - July 2019",
          location: "Zakir Hossain Road, Dhaka 1205",
          description: `Introduced a JavaScript component library, resulting in a 30% 
                    decrease in development time and a 40% enhancement in code reusability, 
                    streamlining project workﬂows and promoting scalability. Collaborated with 
                    backend developers to integrate frontend with server-side logic, improving 
                    system performance by 20%.Integrated the Accountant module for a CMS application, 
                    streamlining ﬁnancial processes and reducing manual workload by 50%.`,
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Personal Projects",
      experiences: [
        {
          title: "Online Learning Platform ",
          company: "",
          company_url: "",
          logo_path: "Webarch.jfif",
          duration: "March 2017 - November 2017",
          location: "",
          description:
            "Developed an online learning platform with user authentication, course categorization, and progress tracking, increasing user engagement by 40%.    HTML, CSS, JavaScript, React.js, MongoDB for user authentication and data storage, Bootstrap for UI components, and React Router for navigation.",
          color: "#4285F4",
        },
        {
          title: "E-Commerce Website with Product Recommendation System",
          company: "",
          company_url: "",
          logo_path: "Webarch.jfif",
          duration: "January 2018 - May 2018",
          location: "",
          description:
            "   Constructed an e-commerce platform with personalized product recommendations, leading to a 25% rise in conversion rates and a 40% surge in user engagement.    Frontend (HTML, CSS, JavaScript, React.js) Backend (Node.js, Express, MongoDB/SQL) Payment Integration (Stripe, PayPal) Personalized Recommendations (Data Analysis, ML) User Authentication (JWT, OAuth) Responsive Design (CSS Media Queries) Admin Panel Development Version Control (Git) Deployment (CI/CD)",
          color: "#4285F4",
        },
        {
          title: "EShop (An E-commerce App) ",
          company: "",
          company_url: "",
          logo_path: "Webarch.jfif",
          duration: "June 2019 - Aug 2019",
          location: "",
          description:
            "It is simple but powerful backend with simple design. It has 3 panel users, admin, seller. Seller can add product that can go to admin and admin can approve product and that goes directly in homepage.\n" +
            "• It also has push notification system. DB: Firebase (NOSQL).",
          color: "#4285F4",
        },
        {
          title: "Phone Bazar ",
          company: "",
          company_url: "",
          logo_path: "CFC.jfif",
          duration: "Jan 2019 – June 2019",
          location: "",
          description:
            "Back-End Development: Laravel, REST, jQuery. Admin and user panel with email verification login and admin access are secure with product checkout status.\n" +
            "• Front-End Development: HTML, CSS and JS.\n" +
            "• DB: MySQL",
          color: "#a60000",
        },
        {
          title: "POTRO",
          company: "",
          company_url: "",
          logo_path: "NTL.jfif",
          duration: "July 2018 – Dec 2018",
          location: "",
          description:
            "Back-End Development: Java, Phone OTP, Facebook User Verification, Google User Verification, Firebase Auth etc.\n" +
            "• It's a WhatsApp like chat app using Email address and Phone number authorizations login and beautiful chat screen with profile and status summary Using firebase database.\n" +
            "• DB: NOSQL (Firebase).\n" +
            "• Pictures Optimization with firebase and notification system using json, profile update and push notification system. It has status update with firebase and it has notification system with firebase function.",
          color: "#62cff0",
        },
        {
          title: "Order Foods Restaurant & Server",
          company: "",
          company_url: "",
          logo_path: "Bagcampus.jpg",
          duration: "Jan 2018 – Dec 2018",
          location: "",
          description:
            "Food Orders Apps. Where user can order foods by category and Restaurant quality food order in home.\n" +
            "• User can review, like, comment of any product of any shop. It has 2 panel User and Server.\n" +
            "• DB: NOSQL(Firebase) & SQLite.",
          color: "#0059c9",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I have been working on React JS and NEXT JS for 2 years. I have a vast knowledge of JavaScript and front-end tools like HTML, CSS, SCSS, Bootstrap. I have worked with REST APIs and have strong knowledge about UX design sensibilities. In recent days, I’ve been working with Typescript & React Redux on a real project which is underdeveloped.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile_photo_2.jpeg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others.",
    link: "https://medium.com/@koushik.saha666",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "WholeSale Platform",
      url: "https://moveon.com.bd/",
      description:
        "MoveOn is an experience-based marketplace that brings people more ways to get the most out of their desire to outreach their dream of shopping overseas in dynamic locations",
      languages: [
        {
          name: "React",
          fontAwesomeClassname: "simple-icons:react",
        },
        {
          name: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
        },
        {
          name: "SASS",
          fontAwesomeClassname: "simple-icons:sass",
        },
        {
          name: "CSS3",
          fontAwesomeClassname: "simple-icons:css3",
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
        },
      ],
    },
    {
      id: "1",
      name: "E-Commerce Mobile App",
      url: "http://mobile.ali2bd.com/",
      description:
        "The platform to get product from AliExperss to Bangladesh. You can pay product price in Bangladeshi Taka (BDT).",
      languages: [
        {
          name: "React",
          fontAwesomeClassname: "simple-icons:react",
        },
        {
          name: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
        },
        {
          name: "SASS",
          fontAwesomeClassname: "simple-icons:sass",
        },
        {
          name: "Typescript",
          fontAwesomeClassname: "simple-icons:typescript",
        },
        {
          name: "Less",
          fontAwesomeClassname: "simple-icons:less",
        },
        {
          name: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
        },
        {
          name: "Ant Design",
          fontAwesomeClassname: "simple-icons:react",
        },
      ],
    },
    {
      id: "2",
      name: "Ant Design Admin Panel",
      url: "http://admin.moveon.work/",
      description:
        "Its a admin panel for the E-Commerce Mobile App. You can manage product, order, user, etc.",
      languages: [
        {
          name: "React",
          fontAwesomeClassname: "simple-icons:react",
        },
        {
          name: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
        },
        {
          name: "SASS",
          fontAwesomeClassname: "simple-icons:sass",
        },
        {
          name: "Typescript",
          fontAwesomeClassname: "simple-icons:typescript",
        },
        {
          name: "Less",
          fontAwesomeClassname: "simple-icons:less",
        },
        {
          name: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
        },
        {
          name: "Ant Design",
          fontAwesomeClassname: "simple-icons:react",
        },
      ],
    },
    {
      id: "3",
      name: "E-Commerce Website With Laravel",
      url: "http://admin.moveon.work/",
      description:
        "E-Commerce Website with Laravel. You can buy product from this website.",
      languages: [
        {
          name: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
        },
        {
          name: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
        },
        {
          name: "CSS3",
          fontAwesomeClassname: "simple-icons:css3",
        },
        {
          name: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
        },
        {
          name: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
        },
        {
          name: "Vue",
          fontAwesomeClassname: "simple-icons:vuejs",
        },
      ],
    },
    {
      id: "4",
      name: "EShop (An E-commerce App) ",
      url: "/",
      description:
        "It is simple but powerful backend with simple design. It has 3 panel users, admin, seller.",
      languages: [
        {
          name: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
        },
        {
          name: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
        },
        {
          name: "CSS3",
          fontAwesomeClassname: "simple-icons:css3",
        },
        {
          name: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
        },
        {
          name: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
        },
      ],
    },
    {
      id: "5",
      name: "Phone Bazar",
      url: "/",
      description:
        "Back-End Development: Laravel, REST, jQuery. Admin and user panel with email verification login and admin access are secure with product checkout status.",
      languages: [
        {
          name: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
        },
        {
          name: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
        },
        {
          name: "CSS3",
          fontAwesomeClassname: "simple-icons:css3",
        },
        {
          name: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
        },
        {
          name: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
        },
      ],
    },
    {
      id: "6",
      name: "POTRO",
      url: "/",
      description:
        "Java, Phone OTP, Facebook User Verification, Google User Verification, Firebase Auth etc.",
      languages: [
        {
          name: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
        },
        {
          name: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
        },
        {
          name: "CSS3",
          fontAwesomeClassname: "simple-icons:css3",
        },
        {
          name: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
        },
        {
          name: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
        },
      ],
    },
    {
      id: "7",
      name: "Order Foods Restaurant & Server",
      url: "http://admin.moveon.work/",
      description:
        "Food Orders Apps. Where user can order foods by category and Restaurant quality food order in home.",
      languages: [
        {
          name: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
        },
        {
          name: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
        },
        {
          name: "CSS3",
          fontAwesomeClassname: "simple-icons:css3",
        },
        {
          name: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
        },
        {
          name: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
